import { Injectable } from "@angular/core";
import { SidenavItemComponent } from "./sidenav-item/sidenav-item.component";
import { SidenavComponent } from "./sidenav.component";
import { Subject } from "rxjs";
import { ActivatedRouteSnapshot } from "@angular/router";

export interface SidenavBusEvent {
	activeItemId: string;
	isDirectChild: boolean;
	item: SidenavItemComponent;
}

@Injectable()
export class SidenavService {
	get itemsFlat() {
		return this._itemsFlat;
	}
	set itemsFlat(v: { [id: string]: SidenavItemComponent }) {
		this._itemsFlat = v;
	}
	$activeItemId: Subject<string> = new Subject<string>();
	$eventBus: Subject<SidenavBusEvent> = new Subject<SidenavBusEvent>();
	private itemsContainer: SidenavComponent;
	private _itemsFlat: { [id: string]: SidenavItemComponent } = {};



	constructor() { }

	setParent(parent: SidenavComponent): void {
		this.itemsContainer = parent;
	}

	addItems(items: SidenavItemComponent[]): void {
		items.forEach(item => {
			this.addItem(item);
		});
	}

	addItem(item: SidenavItemComponent): void {
		if (!this.itemsFlat) {
			this.itemsFlat = {};
		}

		this.itemsFlat[item.id] = item;
	}

	removeItem(id: string): void {
		delete this.itemsFlat[id];
	}

	getCurrentRouteSnapshot() {
		return this.itemsContainer ? this.itemsContainer.currentPage : null;
	}

	closeAllItems() {
		if (this.itemsFlat) {
			Object.keys(this.itemsFlat).forEach(key => {
				this.itemsFlat[key].isExpanded = false;
			});
		}
	}

	// tries to find a sidenav item for a specific route. returns the id of that item.
	findMatchingItemForRoute(routeSnapshot: ActivatedRouteSnapshot): string {
		return !!routeSnapshot
			? Object.keys(this.itemsFlat).find(key => {
				return (
					this.itemsFlat[key].router &&
					routeSnapshot.url.length &&
					routeSnapshot.url[0].path === this.itemsFlat[key].routeName &&
					this.itemsFlat[key].expandable
				);
			})
			: null;
	}

	checkIfDirectChild(item: SidenavItemComponent): boolean {
		if (this.itemsContainer.items) {
			return this.itemsContainer.items.some(directChild => {
				return directChild === item;
			});
		} else {
			return false;
		}
	}
}
